import constants_default from '^/components/global/constants';

export default {
  ...constants_default,
  // create customer default
  IS_REGISTER_DEFAULT: true,
}



// WEBPACK FOOTER //
// ./ixcms/themes/gqf/src/vue-src/components/global/constants.js